import { actions } from 'modules/common';
import { schemas } from 'modules/data';
import { hooks as pageHooks } from 'modules/page';
import { normalize } from 'normalizr';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { usePrevious } from 'react-use';
import { useGetCompaniesRaw } from 'shared/data/webApp/v1';
import { useExpandedCompany } from 'shared/hooks/useExpandedCompany';
import { getDefaultPath } from 'urlBuilder';

import { loadPageData } from '../actions';

export const usePageData = () => {
    const dispatch = useDispatch();
    const history = useHistory();

    const { companyId } = useParams<{ companyId: string }>();

    const { data, isInitialLoading, isSuccess, error, dataUpdatedAt } = useGetCompaniesRaw({
        query: { companyId },
    });

    const company = useExpandedCompany(companyId);

    /**
     * TODO Fix workaround: Checking options.dataUpdatedAt !== prevDataUpdatedAt is necessary to prevent an infinite
     * useEffect loop in case there are delegates in company, and the user navigates through the following pages
     * CompanyInfo -> Users (or another page) -> CompanyInfo.
     */
    const prevDataUpdatedAt = usePrevious(dataUpdatedAt);

    useEffect(() => {
        if (isSuccess && dataUpdatedAt !== prevDataUpdatedAt) {
            const { entities } = normalize(data, { Companies: [schemas.companySchemaLegacy] });

            dispatch(actions.updateEntities(entities));

            if (!entities.companies?.[companyId]) {
                history.push(getDefaultPath());
            }
        }
    }, [companyId, data, dataUpdatedAt, dispatch, history, isSuccess, prevDataUpdatedAt]);

    useEffect(() => {
        dispatch(loadPageData());
    }, [companyId, dispatch]);

    pageHooks.usePageError(error);

    return { isInitialLoading, company };
};
